/**
 * Dev: Frontend + API both deployed to dev environment.
 */
export const environment = {
  production: false,
  apiUrl: 'https://q6c8eq00o8.execute-api.us-east-1.amazonaws.com/api',
  cognito: {
    userPoolId: 'us-east-1_wj1g4akaJ',
    userPoolClientId: '49na0365vhn2jmadjvmfka6jvb',
    region: 'us-east-1',
  },
  /** Admin emails for UI visibility. Backend enforces via ADMIN_EMAILS env. */
  adminEmails: ['ychengxx@gmail.com', 'ycheng22@hotmail.com'] as string[],
};
